import { render, staticRenderFns } from "./teacherPart.vue?vue&type=template&id=3f094328&scoped=true"
import script from "./teacherPart.vue?vue&type=script&lang=js"
export * from "./teacherPart.vue?vue&type=script&lang=js"
import style0 from "./teacherPart.vue?vue&type=style&index=0&id=3f094328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f094328",
  null
  
)

export default component.exports